import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Modal from 'utils/packages/Modal';
import Spacer from 'design-system/Spacer';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
export const LowLimitPriceModalContent = ({ handleEdit, handleContinue }) => {
    const onEdit = useCallback(() => {
        Modal.hide();
        handleEdit();
    }, [handleEdit]);
    const onContinue = useCallback(() => {
        Modal.hide();
        handleContinue();
    }, [handleContinue]);
    return (<View style={styles.contentContainer}>
      <Spacer h={16}/>
      <Text TextThin-14 Secondary centered>
        {'Your limit price is below the current indicative market price so your order will most likely be filled immediately'}
      </Text>
      <Spacer h={16}/>
      <Button brandReversed title="Edit limit price" onPress={onEdit}/>
      <Spacer h={8}/>
      <Button brand title="Continue" onPress={onContinue}/>
    </View>);
};
const LowLimitPriceModal = {
    show: (handleContinue, handleEdit) => {
        Modal.show(<LowLimitPriceModalContent handleEdit={handleEdit} handleContinue={handleContinue}/>, {
            title: 'Low limit price',
            containerStyle: styles.modal,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    contentContainer: {
        paddingHorizontal: rem(16),
    },
});
export default LowLimitPriceModal;
